<template>
  <div class="supplier-managenment">
    <div class="supplier-managenment-container">
      <div class="top-container">
        <div class="title">供应商管理</div>
        <div class="search">
          <el-input prefix-icon="el-icon-search" class="gray white w240" placeholder="请输入供应商名称/食堂名称" v-model="searchVal" @keyup.enter.native="search"></el-input>
          <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleAddSupplier
              ) !== -1
            "
            type="text"
            class="btn-blue add"
            icon="el-icon-plus"
            @click="openAddMaterial"
            >新增</el-button
          >
        </div>
      </div>
      <div class="table" v-if="tableData.length > 0">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.lable"
            :width="item.width"
            :show-overflow-tooltip="item.showOverflowTooltip"
          />
          <el-table-column label="服务范围" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.controlLimit != '—'"
                effect="dark"
                placement="top-start"
              >
                <div slot="content">
                  <div
                    v-for="(item, index) in scope.row.supplierCanteenList"
                    :key="index"
                  >
                    {{ item.canteenName }}
                    <br />
                  </div>
                </div>
                <p class="controlLimit">{{ scope.row.controlLimit }}</p>
              </el-tooltip>
              <p v-else class="controlLimit">{{ scope.row.controlLimit }}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleSupplierMethod
              ) !== -1
            "
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="btn-text"
                @click="openModMaterial(scope.row)"
                >编辑</el-button
              >
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="beforeHandleCommand(scope.row, 'mod')"
                    class="mod"
                    >修改密码</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="!scope.row.isFrozen"
                    :command="beforeHandleCommand(scope.row, 'frozen')"
                    class="frozen"
                    >冻结</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="beforeHandleCommand(scope.row, 'thaw')"
                    class="frozen"
                    >解冻</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="beforeHandleCommand(scope.row, 'delete')"
                    class="delete"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../assets/nothing.png" />
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>

    <!-- 修改供应商密码 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="密码" prop="pwd">
          <el-input class="gray white" v-model="form.pwd"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :modal="false"
      :with-header="false"
      :wrapperClosable="false"
    >
      <div class="drawer-title">
        <i class="el-icon-close" @click="closeDrawer"></i>
        <div>
          <el-button type="text" class="btn-gray" @click="closeDrawer"
            >取消</el-button
          >
          <el-button
            type="text"
            class="btn-blue"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
        </div>
      </div>
      <div class="sub-title">{{ isMod ? "编辑" : "创建" }}</div>
      <el-form
        :model="ruleForm"
        :rules="ruleFormRules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="供应商名称" prop="supplierName">
          <el-input
            class="gray white"
            v-model="ruleForm.supplierName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商类型" prop="supplierType">
          <el-select
            v-model="ruleForm.supplierType"
            placeholder="请选择"
            class="gray white"
            clearable
          >
            <el-option
              v-for="item in supplierTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务范围" prop="controlLimit">
          <el-select
            v-model="ruleForm.controlLimit"
            placeholder="请选择服务范围"
            multiple
            clearable
          >
            <el-option
              v-for="item in canteenList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isMod" label="密码" prop="pwd">
          <el-input
            class="gray white"
            v-model="ruleForm.pwd"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="合作协议">
          <upload-files
            :image="ruleForm.agreement"
            :fileArr="fileList"
            @uploadFile="cooperationAgreement"
          />
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import Supplier from "@/models/supplier.js";
import uploadFiles from "@/components/upload-files.vue";
import { statusMixins } from "@/common/mixins/status/status.js";
import { operationMixins } from "@/common/mixins/operation/operation.js";
import rules from "@/common/js/rule.js";
import Canteen from "@/models/canteen.js";
export default {
  mixins: [statusMixins, operationMixins],

  components: {
    uploadFiles,
  },

  data() {
    return {
      /* 供应商id */
      supplierId: "",
      searchVal: '',
      tableData: [],
      tableTitleList: [
        {
          prop: "name",
          lable: "供应商名称",
          width: "",
          showOverflowTooltip: false,
        },
        {
          prop: "typeVal",
          lable: "供应商类型",
          width: "",
          showOverflowTooltip: false,
        },
      ],
      dialogVisible: false,
      dialogTitle: "密码",
      form: {
        pwd: "",
      },
      rules: {
        pwd: [
          {
            required: true,
            validator: rules.FormValidate.Form().validatePwd,
            trigger: "blur",
          },
        ],
      },
      /* 是否开启抽屉 */
      drawer: false,
      /* 是否编辑; 1.是; 0.否*/
      isMod: "",
      /* 是否清空图片 */
      ruleForm: {
        supplierName: "",
        supplierType: "",
        controlLimit: [],
        pwd: "",
        agreement: [],
      },
      ruleFormRules: {
        supplierName: [
          { required: true, message: "请输入供应商名称", trigger: "blur" },
        ],
        supplierType: [
          { required: true, message: "请选择供应商类型", trigger: "change" },
        ],
        controlLimit: [
          { required: true, message: "请选择服务范围", trigger: "change" },
        ],
        pwd: [
          {
            required: true,
            validator: rules.FormValidate.Form().validatePwd,
            trigger: "blur",
          },
        ],
      },
      supplierTypeList: [
        { id: 1, name: "定点配送" },
        { id: 2, name: "定点采购" },
      ],
      canteenList: [],
      fileList: [],
      /* 供应商id */
      supplierId: "",
      isFrozen: 0,
    };
  },

  created() {
    config();
    this.initCanteenList();
    this.initSupplierList();
  },

  methods: {
    /* 获取供应商管理 */
    initSupplierList() {
      let queryStr = this.searchVal
      Supplier.getSupplierList(queryStr).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.type = i.type;
            obj.typeVal = this.FOOD_SUPPLIER_TYPE[i.type];
            obj.isFrozen = i.isFrozen;
            obj.agreement = i.agreement;
            obj.supplierCanteenList = i.supplierCanteenList;
            let controlLimit = [];
            if (i.supplierCanteenList) {
              i.supplierCanteenList.map((v) => {
                controlLimit.push(v.canteenName);
              });
            }
            if (controlLimit.length > 0) {
              obj.controlLimit = controlLimit.join(";");
            } else {
              obj.controlLimit = "—";
            }
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取食堂数据 */
    initCanteenList() {
      Canteen.getCanteenNoPageList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            arr.push(obj);
          });
          this.canteenList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    search() {
      this.initSupplierList()
    },

    /* 开启新增供应商 */
    openAddMaterial() {
      this.drawer = true;
      this.isMod = 0;
    },

    openModMaterial(row) {
      this.isMod = 1;
      this.supplierId = row.id;
      this.ruleForm.supplierName = row.name;
      this.ruleForm.supplierType = row.type;
      this.ruleForm.agreement = row.agreement ? [row.agreement] : [];
      let fileList = [];
      if (row.agreement) {
        let obj = {};
        obj.url = row.agreement;
        obj.name = row.agreement.split("img/")[1].substring(13);
        fileList.push(obj);
      }
      this.fileList = fileList;
      let imgObj = {};
      imgObj.images = this.ruleForm.agreement;
      imgObj.fileList = fileList;
      this.$bus.emit("init", imgObj);
      let arr = [];
      row.supplierCanteenList.map((i) => {
        arr.push(i.canteenId);
      });
      this.ruleForm.controlLimit = arr;
      this.drawer = true;
    },

    /* 冻结供应商 */
    frozenSupplier() {
      let data = {
        id: this.supplierId,
      };
      Supplier.postFrozenSupplier(data).then((res) => {
        if (res.success) {
          let msg = this.isFrozen ? "冻结成功" : "解冻成功";
          this.$message({
            type: "success",
            message: msg,
          });
          this.initSupplierList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 删除供应商 */
    delSupplier() {
      let data = {
        id: this.supplierId,
      };
      Supplier.postDelSupplier(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.initSupplierList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 修改供应商密码 */
    modSupplierPsw() {
      let data = {
        id: this.supplierId,
        pwd: this.form.pwd,
      };
      Supplier.postModSupplierPsw(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.initSupplierList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 新增供应商 */
    addSupplier() {
      let data = {
        name: this.ruleForm.supplierName,
        type: this.ruleForm.supplierType,
        canteenIdList: this.ruleForm.controlLimit,
        pwd: this.ruleForm.pwd,
        agreement: this.ruleForm.agreement[0],
      };
      Supplier.postAddSupplier(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.initSupplierList();
          this.closeDrawer();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 编辑供应商 */
    modSupplier() {
      let data = {
        id: this.supplierId,
        name: this.ruleForm.supplierName,
        type: this.ruleForm.supplierType,
        canteenIdList: this.ruleForm.controlLimit,
        agreement: this.ruleForm.agreement[0],
      };
      Supplier.postModSupplier(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.initSupplierList();
          this.closeDrawer();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command) {
      return {
        value: value,
        command: command,
      };
    },

    handleCommand(command) {
      switch (command.command) {
        case "mod":
          this.dialogVisible = true;
          this.supplierId = command.value.id;
          break;
        case "frozen":
          this.isFrozen = 1;
          this.supplierId = command.value.id;
          this.$confirm(
            "供应商冻结后无法登录或被选择，是否继续？",
            "确认冻结供应商",
            {
              confirmButtonText: "冻结",
              cancelButtonText: "取消",
              confirmButtonClass: "btn-blue",
              cancelButtonClass: "btn-gray",
            }
          ).then(() => {
            this.frozenSupplier();
          });
          break;
        case "thaw":
          this.isFrozen = 0;
          this.supplierId = command.value.id;
          this.frozenSupplier();
          break;
        case "delete":
          this.supplierId = command.value.id;
          this.$confirm("供应商删除后不可恢复，是否继续？", "确认删除供应商", {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            confirmButtonClass: "btn-red",
            cancelButtonClass: "btn-gray",
          }).then(() => {
            this.delSupplier();
          });
          break;
      }
    },

    handleClose() {
      this.form.pwd = "";
      this.dialogVisible = false;
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.modSupplierPsw();
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    closeDrawer() {
      this.ruleForm.supplierName = "";
      this.ruleForm.supplierType = "";
      this.ruleForm.controlLimit = [];
      this.ruleForm.pwd = "";
      this.supplierId = "";
      this.ruleForm.agreement = [];
      this.fileList = [];
      this.drawer = false;
      this.$bus.emit("clearImgFiles");
    },

    /* 获取合作协议 */
    cooperationAgreement(v) {
      this.ruleForm.agreement = v;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isMod) {
            this.modSupplier();
          } else {
            this.addSupplier();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang='scss'>
.supplier-managenment {
  flex: 1;
  padding: 28px 19px;
  box-sizing: border-box;
  background: $bg-white;
  .supplier-managenment-container {
    height: 100%;
    position: relative;
  }
  .top-container {
    @include flex-between;
    margin-bottom: 20px;
    .title {
      padding-left: 10px;
      font-size: $fs-medium-s;
      color: $color-BlackGrey;
      border-left: 4px solid $color-DeepReddishBlue;
    }
    .search {
      display: flex;
      .add {
        margin-left: 12px;
        padding: 0;
      }
      .el-input__prefix, .el-input__suffix {
        top: 2px;
      }
    }
  }
  .nothing {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }
  .el-dropdown-link {
    margin-left: 20px;
    cursor: pointer;
    color: $color-DeepReddishBlue;
  }

  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__footer {
    @include flex-end;
  }

  .sub-title {
    text-align: left;
    font-size: $fs-medium-s;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-Step;
  }
  .el-drawer__wrapper {
    top: 119px !important;
    right: 20px;
  }

  .el-select__tags {
    top: 4px;
    min-height: 32px;
    transform: translateY(0%);
  }
}
.mod {
  color: $color-grey;
  font-size: $fs-small-l;
}
.delete {
  color: $color-Crimson;
  font-size: $fs-small-l;
}
</style>
